import React from 'react';
import Loader from '../components/Loader';

/**
 * The single seam into App.jsx. Rendered on the existing `mobileView` branch in
 * place of the old wall. When the mobile experience is enabled it takes over
 * with MobileApp; otherwise it renders `children` (the original
 * WelcomeOverlayMobile), so with the flag off mobile behaves exactly as before
 * and desktop is never affected.
 *
 * MobileApp is lazy-loaded so the entire mobile tree (screens, CSS, editors)
 * stays OUT of the main bundle: desktop users — and flag-off mobile users —
 * never download it. The chunk is only fetched on the first enabled render.
 */
const MobileApp = React.lazy(() => import('./MobileApp'));

export default function MobileGate({
  profile,
  role,
  children,
  enabled,
  publicOnly = false,
}) {
  if (!enabled) return children;
  // Teacher Loop (B2m): `publicOnly` is set only when the mobile experience is
  // dark and the route is one of the logged-out pages (/check/*,
  // /view/submissions/*). MobileApp then renders just those routes. Without it
  // MobileApp gets exactly the props it always had.
  return (
    <React.Suspense fallback={<Loader />}>
      {publicOnly ? (
        <MobileApp profile={profile} role={role} publicOnly />
      ) : (
        <MobileApp profile={profile} role={role} />
      )}
    </React.Suspense>
  );
}

/**
 * App's mobile branch passes its already-resolved rendering decision through
 * this seam. That decision can deliberately stay mobile after the physical
 * viewport crosses 765px while a stateful workflow is open. Re-running the
 * literal media query inside MobileGate would disagree with App for one branch,
 * replace MobileApp with the welcome wall, and destroy the form state the hold
 * exists to protect.
 */
export function AppMobileGate({
  mobileExperienceEnabled,
  publicOnly = false,
  profile,
  role,
  children,
}) {
  return (
    <MobileGate
      enabled={mobileExperienceEnabled}
      publicOnly={publicOnly}
      profile={profile}
      role={role}
    >
      {children}
    </MobileGate>
  );
}
